export default __webpack_public_path__ + "static/DownloadIcon-c99f067d8f179c8696e59a62a4e710ac.jpg";